import { createGlobalStyle } from "styled-components";

import Inter from "./Inter";

export default createGlobalStyle`
    ${Inter}
`;
